import Splide from "@splidejs/splide";
import { bindSplideLazyLoad } from './splide-lazy-load';

document.addEventListener('DOMContentLoaded', () => {

    const locationsSlider = document.querySelector('.c-locations-slideshow--cta')

    if (locationsSlider !== null) {

        const locationsSliderCta = new Splide('.c-locations-slideshow--cta', {
            fixedWidth: '100%',
            fixedHeight: '66.6rem',
            rewind: true,
            pagination: false,
            arrows: true,
            cover: true,
            breakpoints: {
                1024: {
                    fixedHeight: '32.3rem',
                },
            },
        })

        locationsSliderCta.mount();
        bindSplideLazyLoad(locationsSliderCta, 1, 1);

    }

    const homepage = document.querySelector('.page-template-template-home')

    if (homepage !== null) {


        document.querySelectorAll('.js-load-more-inspiration').forEach(function (loadMoreInspiration) {
            loadMoreInspiration.addEventListener('click', function () {
                document.querySelectorAll('.c-product-inspiration__single').forEach(function (removeFromSingles) {
                    removeFromSingles.classList.remove('hideOnMobile')
                })
                document.querySelector('.js-load-more-inspiration').style.display = 'none';
            })
        })


    }

})
